import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM8.83979 8.64594C9.13268 8.35305 9.60755 8.35305 9.90045 8.64594L12.1371 10.8826L14.3738 8.64594C14.6667 8.35305 15.1416 8.35305 15.4345 8.64594C15.7274 8.93883 15.7274 9.41371 15.4345 9.7066L13.1978 11.9433L15.4343 14.1798C15.7272 14.4727 15.7272 14.9476 15.4343 15.2405C15.1414 15.5334 14.6666 15.5334 14.3737 15.2405L12.1371 13.004L9.90063 15.2405C9.60773 15.5334 9.13286 15.5334 8.83997 15.2405C8.54707 14.9476 8.54707 14.4727 8.83997 14.1798L11.0765 11.9433L8.83979 9.7066C8.54689 9.41371 8.54689 8.93883 8.83979 8.64594Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const DeleteCircleFilled = React.forwardRef(IconComponent);
DeleteCircleFilled.displayName = 'DeleteCircleFilled';

export { DeleteCircleFilled };
